<div class="modal fade" id="dlg_selecionar_item" tabindex="-1" role="dialog" aria-labelledby="Anular"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 800px;" role="document">
    <div class="modal-content">
      <div class="modal-header bg-danger text-white">
        <h5 class="modal-title" id="title" style="font-size: 1rem;">{{titulo}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-0">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" id="lista-tab" data-toggle="tab" href="#lista" role="tab" aria-controls="lista"
              aria-selected="true">Itens</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="sel-tab" data-toggle="tab" href="#sel" role="tab" aria-controls="sel"
              aria-selected="false">Selecionados</a>
          </li>
        </ul>
        <div class="tab-content" id="tab">
          <div class="tab-pane fade show active overflow-auto" id="lista" role="tabpanel" aria-labelledby="lista-tab"
            style="height: 400px;">
            <div class="row m-0">
              <div class="col-md-12 p-3">
                <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
                </lib-filtro>
              </div>
            </div>
            <div class="row m-0" *ngIf="listaSel(false) && listaSel(false).length > 0">
              <div class="col-12 table-responsive">
                <table class="table table-eddy">
                  <thead>
                    <tr>
                      <th scope="col" class="text-center">Código</th>
                      <th scope="col">Produto</th>
                      <th scope="col" class="text-center">Unidade</th>
                      <th scope="col" class="text-center">Qtde.</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of listaSel(false)">
                      <th scope="row" class="text-center">{{item.produto_unidade.produto.codigo}}</th>
                      <td>{{item.produto_unidade.produto.nome}}</td>
                      <td class="text-center">
                        {{item.produto_unidade.unidade.nome}}
                      </td>
                      <td class="text-center">
                        {{item.quantidade | number:'1.2-2'}}
                      </td>
                      <td style="width: 70px;">
                        <button (click)="selecionar(item, true)" class="btn btn-sm btn-outline-primary mr-2">
                          <i class="fa fa-check text-success"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="tab-pane fade overflow-auto" id="sel" role="tabpanel" aria-labelledby="home-sel"
            style="height: 400px;">
            <div class="row m-0" *ngIf="listaSel(true) && listaSel(true).length > 0">
              <div class="col-12 table-responsive">
                <table class="table table-eddy">
                  <thead>
                    <tr>
                      <th scope="col" class="text-center">Código</th>
                      <th scope="col">Produto</th>
                      <th scope="col" class="text-center">Unidade</th>
                      <th scope="col" class="text-center">Qtde.</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of listaSel(true)">
                      <th scope="row" class="text-center">{{item.produto_unidade.produto.codigo}}</th>
                      <td>{{item.produto_unidade.produto.nome}}</td>
                      <td class="text-center">
                        {{item.produto_unidade.unidade.nome}}
                      </td>
                      <td class="text-center">
                        {{item.quantidade | number:'1.2-2'}}
                      </td>
                      <td style="width: 70px;">
                        <button (click)="selecionar(item, false)" class="btn btn-sm btn-outline-primary pl-2 pr-2 mr-2">
                          <i class="fa fa-close text-danger"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-secondary btn-sm text-white float-left"
            (click)="finalizar()">Finalizar</button>
        </div>
      </div>
    </div>
  </div>